/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель для недавно просмотренных товаров
   */
  app.RecentItem = app.Model.extend({
    url: app.entryScriptName + '/api/v3/recent-item/'
  });
})();

}.call(window));